// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ClientesPreencher_GenerateLinkInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /clientes_preencher/generate_link
 *
 * Authenticated endpoint. Receives a cliente_id and generates
 * a pre-registration fulfillment link if the customer is new.
 */
import { registerContract } from './validate'

export interface ClientesPreencher_GenerateLinkInput {
cliente_id: number
}

registerContract('ClientesPreencher_GenerateLinkInput', {
  cliente_id: { type: 'number',  required: true },
})
